export const DATA_TRANSFER = 'POST_ENROLL_DATA_TRANSFER';
export const EMBEDDED_READY = 'POST_ENROLL_EMBEDDED_READY';